// src/lib/mailingSend.js
// Sends a campaign to a list of addresses in small batches (each request stays well below proxy timeouts).
// The backend records every result in the campaign, skips addresses that already received it
// and stops by itself when Gmail keeps refusing (response.stopped).

export const BATCH_SIZE = 10;

export async function sendCampaignInBatches(api, { campaignId, subject, htmlBody, emails, onProgress }) {
  const total = emails.length;
  const result = { sent: 0, skipped: 0, failed: [], stopped: false, abortError: null, processed: 0, total };

  for (let i = 0; i < total; i += BATCH_SIZE) {
    const batch = emails.slice(i, i + BATCH_SIZE);
    try {
      const res = await api.post('/bookings/email-broadcast', { campaignId, subject, htmlBody, emails: batch });
      result.sent += Number(res?.sent ?? 0);
      result.skipped += Number(res?.skipped ?? 0);
      if (Array.isArray(res?.failed)) result.failed.push(...res.failed);
      result.processed = i + batch.length;
      onProgress?.({ done: result.processed, total });
      if (res?.stopped) { result.stopped = true; break; }
    } catch (e) {
      // whole batch failed (network, timeout, 401 ...): stop; unprocessed addresses stay "offen" in the campaign
      result.abortError = String(e?.message || 'Unbekannter Fehler');
      break;
    }
  }
  return result;
}

// Human-readable summary for the result modal
export function describeSendResult(r) {
  const lines = [`Gesendet: ${r.sent} von ${r.total}`];
  if (r.skipped) lines.push(`Übersprungen (hatten diese E-Mail schon): ${r.skipped}`);
  if (r.failed.length) {
    lines.push('', `Fehlgeschlagen: ${r.failed.length}`);
    lines.push(...r.failed.slice(0, 10).map(f => `• ${f.email} – ${f.error || 'Unbekannter Fehler'}`));
    if (r.failed.length > 10) lines.push(`…und ${r.failed.length - 10} weitere.`);
  }
  if (r.stopped) {
    lines.push('', 'Der Versand wurde automatisch gestoppt, weil Gmail mehrere E-Mails hintereinander abgelehnt hat ' +
      '(wahrscheinlich Versandlimit). Bitte später erneut versuchen.');
  }
  if (r.abortError) lines.push('', `Abgebrochen: ${r.abortError}`);
  if (r.failed.length || r.stopped || r.abortError) {
    lines.push('', 'Fehlgeschlagene und noch offene Empfänger finden Sie im Tab „Versand-Status“ – dort können Sie sie erneut senden.');
  }
  return lines.join('\n');
}
